import { isFrontEndCgi } from "../../../core/common/isFrontEndCgi";
import { v4 as uuid } from 'uuid';
import { cloneFast } from "../../../tools/lang";
import { isAxiosError } from "../../../tools/axios";
import { get, isObject } from "lodash-es";
import { collectionLogService } from "../../collectionLogService";
import { getHostByUrl } from "../../../tools/url";
import { logHandler } from "../../../components/WConsole";
class FrontEndLogger {
  constructor(collectionId, projectId) {
    this.collectionId = collectionId;
    this.projectId = projectId;
    this.seq = uuid().substr(0, 16); // 这个seq还需要发送给用户接口
    this.startTime = Date.now() * 1000;
    this.lastIndex = 0;
    this.logs = [];
  }
  append(info) {
    // @ts-ignore
    const logInfo = info;
    // todo 前端的大对象如何优化
    try {
      logInfo.seq = this.seq;
      logInfo.dimen1 = 'wuji_ds';
      logInfo.dimen2 = 'collection';
      logInfo.dimen3 = 'frontEndHttp';
      logInfo.seqIndex = this.lastIndex;
      this.lastIndex += 1;
      logInfo.seqTime = this.getSeqTime();
      this.logs.push(logInfo);
    } catch (error) {
      console.error(error);
    }
  }
  commit() {
    try {
      // 发完立刻清空，不等待
      const {
        collectionId,
        projectId
      } = this;
      collectionLogService.createLogs(this.logs, {
        collectionId,
        projectId
      });
      this.logs = [];
    } catch (error) {
      console.error(error);
    }
  }
  getSeq() {
    return this.seq;
  }
  getStartTime() {
    return this.startTime / 1000;
  }
  getSeqTime() {
    const now = Date.now();
    const dur = now * 1000 - this.startTime;
    return dur;
  }
}
/**
 *  前端数据源的数据源日志写入逻辑
 */
export const frontEndHttpLogMiddleware = async (ctx, next) => {
  if (!isFrontEndCgi(ctx.cgiInfo)) {
    await next();
    return;
  }
  if (!ctx.loggerForFrontEndHttp) {
    ctx.loggerForFrontEndHttp = new FrontEndLogger(ctx.collectionId, ctx.projectId);
  }
  const logger = ctx.loggerForFrontEndHttp;
  const {
    requestConfig,
    request
  } = ctx;
  // 把无极日志序列号发给用户接口，可能会用到
  requestConfig.headers['xy-ds-log-seq'] = logger.getSeq();
  const paramLogInfo = {
    dimen4: 'setHttpParams',
    dimen5: 'params',
    level: 1,
    msg: request,
    host: getHostByUrl(requestConfig.url),
    url: requestConfig.url
  };
  logger.append(paramLogInfo);
  if (!ctx.beforeRequest) {
    ctx.beforeRequest = () => {
      var _ctx$loggerForFrontEn;
      logger.append({
        dimen4: 'httpRequest',
        dimen5: 'config',
        host: getHostByUrl(requestConfig.url),
        url: requestConfig.url,
        level: 1,
        msg: getRequestMsg(requestConfig)
      });
      (_ctx$loggerForFrontEn = ctx.loggerForFrontEndHttp) === null || _ctx$loggerForFrontEn === void 0 || _ctx$loggerForFrontEn.commit();
    };
  }
  const appendLogSeqToDevtool = async () => {
    var _ctx$collection;
    if (ctx.envId !== 'dev') return;
    await new Promise(r => setTimeout(r, 64));
    logHandler.append({
      seqId: logger.getSeq(),
      isExpired: false,
      originalUrl: ctx.requestConfig.url || '',
      pageId: ctx.pageId,
      timestamp: logger.getStartTime(),
      cgiId: ctx.cgiName,
      cgiName: get(ctx.cgiInfo, 'desc') || get(ctx.cgiInfo, 'name') || ctx.cgiName,
      collectionId: ctx.collectionId,
      collectionName: ((_ctx$collection = ctx.collection) === null || _ctx$collection === void 0 ? void 0 : _ctx$collection.name) || '',
      projectId: ctx.projectId
    });
  };
  try {
    await next();
  } catch (error) {
    logger.append({
      dimen4: 'httpRequestError',
      dimen5: 'error',
      host: getHostByUrl(requestConfig.url),
      url: requestConfig.url,
      level: 4,
      msg: getErrorMsg(getErrorMsg)
    });
    appendLogSeqToDevtool();
    throw error;
  }
  const {
    response
  } = ctx;
  const responseLogInfo = {
    dimen4: 'httpResponse',
    dimen5: 'result',
    level: 1,
    host: getHostByUrl(requestConfig.url),
    url: requestConfig.url,
    msg: getResponseMsg(response)
  };
  logger.append(responseLogInfo);
  logger.commit();
  appendLogSeqToDevtool();
};
export function getRequestMsg(requestConfig) {
  const obj = {
    method: requestConfig.method,
    timeout: requestConfig.timeout,
    responseType: requestConfig.responseType,
    query: requestConfig.params,
    body: requestConfig.data,
    headers: requestConfig.headers
  };
  return cloneFast(obj);
}
function getErrorMsg(err) {
  if (!isObject(err)) {
    return '';
  }
  let res = null;
  if (isAxiosError(err)) {
    var _axiosErr$response;
    const axiosErr = err;
    res = (_axiosErr$response = axiosErr.response) !== null && _axiosErr$response !== void 0 ? _axiosErr$response : null;
  }
  const msg = {
    message: get(err, 'message'),
    stack: get(err, 'stack'),
    ...getResponseMsg(res)
  };
  return msg;
}
export function getResponseMsg(response) {
  return cloneFast({
    body: response === null || response === void 0 ? void 0 : response.data,
    headers: response === null || response === void 0 ? void 0 : response.headers,
    status: response === null || response === void 0 ? void 0 : response.status,
    statusText: response === null || response === void 0 ? void 0 : response.statusText
  });
}
//# sourceMappingURL=frontEndHttpLog.js.map
